export default __webpack_public_path__ + "static/runservice2-c52ba0dc77c1bbb4d4d2c3f5dd850308.png";